import script from "./MealEditRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MealEditRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__